import { useEffect, useState } from "react";
import { config } from "../config";

interface Health {
  environment: string;
  db: string;
  ts: number;
}

interface Latency {
  stub: { p50_ms: number; p95_ms: number; p99_ms: number };
}

export function Admin() {
  const [token, setToken] = useState(localStorage.getItem("bitxian.adminToken") ?? "");
  const [health, setHealth] = useState<Health | null>(null);
  const [latency, setLatency] = useState<Latency | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setError(null);
    try {
      const headers = { "x-admin-token": token };
      const [h, l] = await Promise.all([
        fetch(`${config.apiBaseUrl}/v1/admin/health`, { headers }).then((r) => r.json()),
        fetch(`${config.apiBaseUrl}/v1/admin/provider-latency`, { headers }).then((r) => r.json()),
      ]);
      if (!h.ok) throw new Error(h.error?.message ?? "health failed");
      if (!l.ok) throw new Error(l.error?.message ?? "latency failed");
      setHealth(h.data);
      setLatency(l.data);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  useEffect(() => {
    if (token) load();
  }, []);

  function saveToken() {
    localStorage.setItem("bitxian.adminToken", token);
    load();
  }

  return (
    <div className="page">
      <h1>Admin</h1>
      <div className="form-row">
        <input
          type="password"
          placeholder="Admin token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          style={{ flex: 1 }}
        />
        <button type="button" className="btn btn-primary" onClick={saveToken}>
          Authenticate
        </button>
      </div>
      {error && <div className="error">{error}</div>}
      <div className="list-grid">
        <div className="list-card">
          <h3>System health</h3>
          {health ? (
            <ul>
              <li>
                <strong>Environment:</strong> {health.environment}
              </li>
              <li>
                <strong>D1:</strong> {health.db}
              </li>
              <li>
                <strong>Last check:</strong> {new Date(health.ts * 1000).toLocaleTimeString()}
              </li>
            </ul>
          ) : (
            <div className="muted">No data.</div>
          )}
        </div>
        <div className="list-card">
          <h3>Provider latency</h3>
          {latency ? (
            <ul>
              <li>p50 {latency.stub.p50_ms} ms</li>
              <li>p95 {latency.stub.p95_ms} ms</li>
              <li>p99 {latency.stub.p99_ms} ms</li>
            </ul>
          ) : (
            <div className="muted">No data.</div>
          )}
        </div>
      </div>
    </div>
  );
}
